import styled from "@emotion/styled";

/* ROOT */
export const HeaderRoot = styled.header`
  width: 100%;
  // background: linear-gradient(180deg, #2b2b2b 0%, #242424 100%);
  background: linear-gradient(180deg, #1a1a1a 0%, #121212 100%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
`;

/* WRAPPER */
export const HeaderInner = styled.div`
  width: 100%;
  height: 76px;
  padding: 0 24px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    height: 64px;
    padding: 0 16px;
  }
`;

/* LEFT */
export const Left = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
`;

export const Logo = styled.a`
  font-family: ui-serif, Georgia, "Times New Roman", serif;
  font-size: 25px;
  letter-spacing: 1px;
  color: #d6c6a5;
  text-decoration: none;

  @media (max-width: 1024px) {
    font-size: 28px;
  }

  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

/* RIGHT */
export const Right = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 15px;
  margin-left: auto;

  @media (max-width: 1024px) {
    gap: 20px;
  }

  @media (max-width: 768px) {
    gap: 10px;
  }
`;

export const Nav = styled.nav`
  display: flex;
  align-items: center;
  gap: 32px;

  @media (max-width: 1024px) {
    gap: 20px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const NavItem = styled.a`
  font-family: ui-serif, Georgia, "Times New Roman", serif;
  font-size: 18px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.82);
  text-decoration: none;

  &:hover {
    color: #ffffff;
  }

  @media (max-width: 1024px) {
    font-size: 16px;
  }
`;

export const SellButton = styled.button`
  height: 38px;
  padding: 0 14px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  background: transparent;
  color: #fff;
  cursor: pointer;
  font-family: ui-serif, Georgia, "Times New Roman", serif;
  font-size: 16px;
  letter-spacing: 0.8px;
  text-transform: uppercase;

  &:hover {
    border-color: #fff;
  }

  @media (max-width: 1024px) {
    height: 34px;
    font-size: 14px;
    padding: 0 12px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const IconButton = styled.button`
  width: 34px;
  height: 34px;
  border: none;
  background: transparent;
  cursor: pointer;
  color: rgba(255, 255, 255, 0.75);
  font-size: 18px;
  display: grid;
  place-items: center;

  &:hover {
    color: #fff;
  }

  @media (max-width: 768px) {
    width: 30px;
    height: 30px;
    font-size: 16px;
  }
`;
